module.exports = __webpack_public_path__ + "img/icon_t12.766c9885.png";